export default __webpack_public_path__ + "static/media/Wellcome.74758966.svg";